import React from "react";

import Paper from "@mui/material/Paper";
import { PaperProps } from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import Fade from "@mui/material/Fade";

interface ShadowPaperProps {
  // Add any additional props you need
  locked: boolean;
  unlockButtonText?: string;
  handleUnlock?: () => void;
  padding: number;
  PaperProps?: PaperProps;
  children?: React.ReactNode;
}

function ShadowPaper(props: ShadowPaperProps) {
  return (
    <Paper {...props.PaperProps}>
      <Box sx={{ zIndex: 0, position: "relative", height: "100%", width: "100%" }}>
        <Fade in={props.locked}>
          <Box
            sx={{
              background: "rgba(0, 0, 0, 0.5)",
              width: "100%",
              height: "100%",
              position: "absolute",
              zIndex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backdropFilter: "blur(2px)",
            }}
          >
            {props.unlockButtonText !== undefined && (
              <Button variant="contained" color="warning" startIcon={<LockOutlinedIcon />} onClick={props.handleUnlock}>
                {props.unlockButtonText}
              </Button>
            )}
          </Box>
        </Fade>
        <Box
          sx={{
            padding: props.padding,
            height: "100%",
            width: "100%",
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          {props.children}
        </Box>
      </Box>
    </Paper>
  );
}

export default ShadowPaper;
